<vdw-header svgIcon="schedule-24px" [title]="'TEXTILE_DATA.FIXED_ORDER.FIXED_ORDER' | bmsTranslate: {count: 2}" [canShowClose]="true" class="border" (closeEvent)="closeMachineDetail()"></vdw-header>
<div class="search-container border">
  <vdw-filter [filteredText]="nameFilter()" (filteredTextChanged)="nameFilter.set($event)"></vdw-filter>
</div>
<div class="fixed-schedules flex-grow overflow-auto">
  @for (schedule of filteredFixedSchedules(); track $index) {
    <ng-template #dragTemplate>
      <app-fixed-schedule-placeholder [fixedSchedule]="schedule"></app-fixed-schedule-placeholder>
    </ng-template>

    <div class="fixed-schedule flex-row p-16 border" [class.active]="false" [draggable]="true" (dragstart)="onDragStart($event, schedule, dragTemplate)">
      <mat-icon svgIcon="drag" class="drag-handle"></mat-icon>
      <div class="text-content flex-center">
        <p class="b1 font-weight-semibold" vdw-ellipsis-label [text]="schedule.name"></p>
      </div>
    </div>
  }
</div>
